// import PowerUpRegisterPage from "./pages/register/RegisterPage.vue";
// import PowerUpLoginPage from "./pages/login/LoginPage.vue";
// import PowerUpForgotPasswordPage from "./pages/forgot-password/ForgotPasswordPage.vue";
// import { linkToHrefWithHost } from "@saflib/links";
// import { appLinks } from "@vendata/power-up-links";
import { createKratosAuthRouter } from "@saflib/ory-kratos-spa/router";

export const createPowerUpAuthRouter = () => {
  return createKratosAuthRouter();
};

// export const createPowerUpAuthRouter = () =>
//   createAuthRouter({
//     logoutRedirect: linkToHrefWithHost(authLinks.login),
//     loginRedirect: linkToHrefWithHost(appLinks.home),
//     additionalRoutes: [
//       {
//         path: authLinks.login.path,
//         component: PowerUpLoginPage,
//         meta: {
//           disableContainer: true,
//         },
//       },
//       {
//         path: authLinks.register.path,
//         component: PowerUpRegisterPage,
//         meta: {
//           disableContainer: true,
//         },
//       },
//       {
//         path: authLinks.forgot.path,
//         component: PowerUpForgotPasswordPage,
//         meta: {
//           disableContainer: true,
//         },
//       },
//     ],
//   });
